'use strict';

export default {
	IMAGE_CELL: 'Image Cell',
	DROP_FILE: 'Select/drop...',
	TOO_MANY_FILES: 'You can only drop one file',
	WRONG_EXTENSION: 'Faulty file type',
	ERROR: 'Bad. Something went wrong when uploading!'
};
